import { render, staticRenderFns } from "./ProductPurchase.vue?vue&type=template&id=303bf516&scoped=true"
import script from "./ProductPurchase.vue?vue&type=script&lang=ts"
export * from "./ProductPurchase.vue?vue&type=script&lang=ts"
import style0 from "./ProductPurchase.vue?vue&type=style&index=0&id=303bf516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303bf516",
  null
  
)

export default component.exports